'use client';
import { useCallback, useEffect, useState } from 'react';
import { ActivePeersSchema } from 'types/dist/validators/common.validators';
import { useRoom } from './useRoom';

export const useActivePeers = () => {
  const { room } = useRoom();

  const [activePeerIds, setActivePeerIds] = useState<string[]>([]);

  const [dominantSpeakerId, setDominantSpeakerId] = useState('');

  const handleSpeakerChange = useCallback(
    (data: { peerIds: string[]; dominantSpeaker: string }) => {
      const result = ActivePeersSchema.safeParse(data);

      if (result.success) {
        setActivePeerIds(result.data.peerIds);
        setDominantSpeakerId(result.data.dominantSpeaker);
      }
    },
    [],
  );

  useEffect(() => {
    room.on('active-speakers-change', handleSpeakerChange);

    return () => {
      room.off('active-speakers-change', handleSpeakerChange);
    };
  }, []);

  /**
   * Update the number of peerIds to notify.
   * @param size
   */
  const updateSize = useCallback((size: number) => {
    if (!room?.activeSpeakers) {
      console.warn(
        'activeSpeakers is not initialized, use localPeer.activateSpeakerNotification',
      );

      return;
    }
    room?.activeSpeakers?.updateSize(size);
  }, []);

  return {
    activePeerIds,
    dominantSpeakerId,
    updateSize,
  };
};
